import type { DragEndEvent } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';

/**
 * Reorders `items` from a @dnd-kit drag-end event using `itemIds` for index lookup.
 * Returns null when the drop is a no-op or indexes cannot be resolved.
 */
export function reorderByDragEnd<T>(event: DragEndEvent, items: T[], itemIds: string[]): T[] | null {
    const { active, over } = event;
    if (!over || active.id === over.id) {
        return null;
    }

    const oldIndex = itemIds.indexOf(String(active.id));
    const newIndex = itemIds.indexOf(String(over.id));
    if (oldIndex === -1 || newIndex === -1) {
        return null;
    }

    return arrayMove(items, oldIndex, newIndex);
}
